var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalProActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215,
    height: 120,
    viewBox: "0 0 215 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11494"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16764"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16589",
    transform: "translate(139.864 36.794)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 15121",
    width: 75,
    height: 47,
    rx: 6,
    transform: "translate(-.046 -.256)",
    style: {
      fill: "#ed7546"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(4.027 34.705)",
    style: {
      fontSize: 32,
      fontFamily: "Inter-Bold,Inter",
      fontWeight: 700,
      fill: "#fff"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRO")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16590"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.346 68.353a11.934 11.934 0 0 0-2.488-3.837 11 11 0 0 0-3.71-2.509 11.231 11.231 0 0 0-4.533-.907 8.85 8.85 0 0 0-1.623.169 10.88 10.88 0 0 0-1.623.443 7.968 7.968 0 0 0-1.455.759 5.361 5.361 0 0 0-1.117 1.054V52.9H276v20.259a12.567 12.567 0 0 0 .907 4.849 11.973 11.973 0 0 0 2.488 3.795 11.482 11.482 0 0 0 3.71 2.488 11.659 11.659 0 0 0 4.532.885 11.964 11.964 0 0 0 4.533-.864 11.369 11.369 0 0 0 3.71-2.445 11.613 11.613 0 0 0 2.488-3.816 12.634 12.634 0 0 0 .906-4.891 12.286 12.286 0 0 0-.928-4.807zm-5.4 7.252a5.875 5.875 0 0 1-1.244 1.961 6.208 6.208 0 0 1-1.855 1.328 5.306 5.306 0 0 1-2.235.464 5.472 5.472 0 0 1-2.256-.464 5.683 5.683 0 0 1-1.834-1.328 6.228 6.228 0 0 1-1.244-1.961 6.635 6.635 0 0 1-.443-2.445 6.107 6.107 0 0 1 .443-2.3 6.459 6.459 0 0 1 3.078-3.373 4.927 4.927 0 0 1 2.256-.527 5.306 5.306 0 0 1 2.235.464 5.49 5.49 0 0 1 1.855 1.307 6.33 6.33 0 0 1 1.244 1.982 6.678 6.678 0 0 1 0 4.891z",
    transform: "translate(-169.05 -7.989)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.38 95.11a10.839 10.839 0 0 0-3.71-2.445 11.572 11.572 0 0 0-4.533-.864 11.3 11.3 0 0 0-4.533.907 11.835 11.835 0 0 0-3.71 2.53 11.613 11.613 0 0 0-2.488 3.816 12.43 12.43 0 0 0-.907 4.807 12.292 12.292 0 0 0 .907 4.764 12.069 12.069 0 0 0 2.488 3.816 12.319 12.319 0 0 0 3.71 2.53 11.784 11.784 0 0 0 9.065 0 12.316 12.316 0 0 0 3.71-2.53 11.837 11.837 0 0 0 2.488-3.816 12.292 12.292 0 0 0 .907-4.764 12.773 12.773 0 0 0-.907-4.933 11.4 11.4 0 0 0-2.487-3.818zm-2.909 11.279a5.877 5.877 0 0 1-1.244 1.961 5.653 5.653 0 0 1-4.09 1.708 5.472 5.472 0 0 1-2.256-.464 5.683 5.683 0 0 1-1.834-1.328 6.372 6.372 0 0 1-1.665-4.406 6.927 6.927 0 0 1 .443-2.53 5.828 5.828 0 0 1 1.223-1.961 5.5 5.5 0 0 1 1.834-1.265 5.815 5.815 0 0 1 2.256-.443 5.637 5.637 0 0 1 2.235.443 4.858 4.858 0 0 1 1.855 1.265 6.228 6.228 0 0 1 1.244 1.961 7.132 7.132 0 0 1 0 5.06z",
    transform: "translate(-71.586 -38.688)",
    style: {
      fill: "#0a243f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.376 117.19v-14.462a2.778 2.778 0 0 1 .211-1.117 2.844 2.844 0 0 1 .611-.928 2.556 2.556 0 0 1 .907-.611 2.945 2.945 0 0 1 1.117-.232 2.787 2.787 0 0 1 1.117.232 2.545 2.545 0 0 1 .928.611 2.632 2.632 0 0 1 .611.928 2.945 2.945 0 0 1 .232 1.117v14.462h5.819v-14.462a2.777 2.777 0 0 1 .211-1.117 2.844 2.844 0 0 1 .611-.928 2.556 2.556 0 0 1 .907-.611 2.945 2.945 0 0 1 1.117-.232 2.787 2.787 0 0 1 1.117.232 2.545 2.545 0 0 1 .928.611 2.632 2.632 0 0 1 .611.928 2.945 2.945 0 0 1 .232 1.117v14.462h5.9v-14.272a9.7 9.7 0 0 0-4.575-7.885 7.96 7.96 0 0 0-.738-.358A8.243 8.243 0 0 0 20.88 94a8.4 8.4 0 0 0-1.6.148 7.072 7.072 0 0 0-1.581.443 6.987 6.987 0 0 0-1.434.822 5.709 5.709 0 0 0-1.223 1.244 6.406 6.406 0 0 0-2.677-2.066 8.405 8.405 0 0 0-6.135-.021 9.3 9.3 0 0 0-2.235 1.244A9.733 9.733 0 0 0 .6 101.863v15.327z",
    transform: "translate(48.291 -40.424)",
    style: {
      fill: "#0a243f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.112 46.721)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 919",
    cx: 18.39,
    cy: 18.39,
    r: 18.39,
    style: {
      fill: "#72cc72"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58277",
    d: "M82.534 64.146a18.444 18.444 0 0 1-18.39 18.39 18.1 18.1 0 0 1-14.367-6.9 18.144 18.144 0 0 0 11.494 4.023 18.444 18.444 0 0 0 18.39-18.39 18.144 18.144 0 0 0-4.023-11.494 18.1 18.1 0 0 1 6.896 14.371z",
    transform: "translate(-45.754 -45.756)",
    style: {
      fill: "#73be73"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58278",
    d: "m118.093 124.514-11.953 13.1a1.963 1.963 0 0 1-2.988 0l-5.057-5.632a2.033 2.033 0 1 1 2.988-2.759l3.563 4.023L115.1 121.87a2.016 2.016 0 0 1 2.873-.115 1.982 1.982 0 0 1 .12 2.759z",
    transform: "translate(-89.703 -111.411)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalProActive);
export default __webpack_public_path__ + "static/media/modalProActive.4d401695ff2bb5412a9372383542e5f4.svg";
export { ForwardRef as ReactComponent };